// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---node-modules-smooth-doc-src-pages-404-js": function componentNodeModulesSmoothDocSrcPages404Js() {
    return import("./../smooth-doc/src/pages/404.js"
    /* webpackChunkName: "component---node-modules-smooth-doc-src-pages-404-js" */
    );
  },
  "component---src-pages-docs-api-loadable-component-mdx": function componentSrcPagesDocsApiLoadableComponentMdx() {
    return import("./../../src/pages/docs/api-loadable-component.mdx"
    /* webpackChunkName: "component---src-pages-docs-api-loadable-component-mdx" */
    );
  },
  "component---src-pages-docs-api-loadable-server-mdx": function componentSrcPagesDocsApiLoadableServerMdx() {
    return import("./../../src/pages/docs/api-loadable-server.mdx"
    /* webpackChunkName: "component---src-pages-docs-api-loadable-server-mdx" */
    );
  },
  "component---src-pages-docs-api-loadable-webpack-plugin-mdx": function componentSrcPagesDocsApiLoadableWebpackPluginMdx() {
    return import("./../../src/pages/docs/api-loadable-webpack-plugin.mdx"
    /* webpackChunkName: "component---src-pages-docs-api-loadable-webpack-plugin-mdx" */
    );
  },
  "component---src-pages-docs-babel-plugin-mdx": function componentSrcPagesDocsBabelPluginMdx() {
    return import("./../../src/pages/docs/babel-plugin.mdx"
    /* webpackChunkName: "component---src-pages-docs-babel-plugin-mdx" */
    );
  },
  "component---src-pages-docs-code-splitting-mdx": function componentSrcPagesDocsCodeSplittingMdx() {
    return import("./../../src/pages/docs/code-splitting.mdx"
    /* webpackChunkName: "component---src-pages-docs-code-splitting-mdx" */
    );
  },
  "component---src-pages-docs-component-splitting-mdx": function componentSrcPagesDocsComponentSplittingMdx() {
    return import("./../../src/pages/docs/component-splitting.mdx"
    /* webpackChunkName: "component---src-pages-docs-component-splitting-mdx" */
    );
  },
  "component---src-pages-docs-delay-mdx": function componentSrcPagesDocsDelayMdx() {
    return import("./../../src/pages/docs/delay.mdx"
    /* webpackChunkName: "component---src-pages-docs-delay-mdx" */
    );
  },
  "component---src-pages-docs-dynamic-import-mdx": function componentSrcPagesDocsDynamicImportMdx() {
    return import("./../../src/pages/docs/dynamic-import.mdx"
    /* webpackChunkName: "component---src-pages-docs-dynamic-import-mdx" */
    );
  },
  "component---src-pages-docs-error-boundaries-mdx": function componentSrcPagesDocsErrorBoundariesMdx() {
    return import("./../../src/pages/docs/error-boundaries.mdx"
    /* webpackChunkName: "component---src-pages-docs-error-boundaries-mdx" */
    );
  },
  "component---src-pages-docs-fallback-mdx": function componentSrcPagesDocsFallbackMdx() {
    return import("./../../src/pages/docs/fallback.mdx"
    /* webpackChunkName: "component---src-pages-docs-fallback-mdx" */
    );
  },
  "component---src-pages-docs-faq-mdx": function componentSrcPagesDocsFaqMdx() {
    return import("./../../src/pages/docs/faq.mdx"
    /* webpackChunkName: "component---src-pages-docs-faq-mdx" */
    );
  },
  "component---src-pages-docs-getting-started-mdx": function componentSrcPagesDocsGettingStartedMdx() {
    return import("./../../src/pages/docs/getting-started.mdx"
    /* webpackChunkName: "component---src-pages-docs-getting-started-mdx" */
    );
  },
  "component---src-pages-docs-library-splitting-mdx": function componentSrcPagesDocsLibrarySplittingMdx() {
    return import("./../../src/pages/docs/library-splitting.mdx"
    /* webpackChunkName: "component---src-pages-docs-library-splitting-mdx" */
    );
  },
  "component---src-pages-docs-loadable-vs-react-lazy-mdx": function componentSrcPagesDocsLoadableVsReactLazyMdx() {
    return import("./../../src/pages/docs/loadable-vs-react-lazy.mdx"
    /* webpackChunkName: "component---src-pages-docs-loadable-vs-react-lazy-mdx" */
    );
  },
  "component---src-pages-docs-migrate-from-react-loadable-mdx": function componentSrcPagesDocsMigrateFromReactLoadableMdx() {
    return import("./../../src/pages/docs/migrate-from-react-loadable.mdx"
    /* webpackChunkName: "component---src-pages-docs-migrate-from-react-loadable-mdx" */
    );
  },
  "component---src-pages-docs-prefetching-mdx": function componentSrcPagesDocsPrefetchingMdx() {
    return import("./../../src/pages/docs/prefetching.mdx"
    /* webpackChunkName: "component---src-pages-docs-prefetching-mdx" */
    );
  },
  "component---src-pages-docs-server-side-rendering-mdx": function componentSrcPagesDocsServerSideRenderingMdx() {
    return import("./../../src/pages/docs/server-side-rendering.mdx"
    /* webpackChunkName: "component---src-pages-docs-server-side-rendering-mdx" */
    );
  },
  "component---src-pages-docs-support-mdx": function componentSrcPagesDocsSupportMdx() {
    return import("./../../src/pages/docs/support.mdx"
    /* webpackChunkName: "component---src-pages-docs-support-mdx" */
    );
  },
  "component---src-pages-docs-suspense-mdx": function componentSrcPagesDocsSuspenseMdx() {
    return import("./../../src/pages/docs/suspense.mdx"
    /* webpackChunkName: "component---src-pages-docs-suspense-mdx" */
    );
  },
  "component---src-pages-docs-timeout-mdx": function componentSrcPagesDocsTimeoutMdx() {
    return import("./../../src/pages/docs/timeout.mdx"
    /* webpackChunkName: "component---src-pages-docs-timeout-mdx" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  }
};